<template>
    <li>
        <router-link
            :to="{name: to}"
            class="flex items-center py-2 px-4 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-orange-700 group">
           
            <font-awesome-icon :icon="icon" class="w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-orange-700 dark:group-hover:text-white" />

            <span class="ml-3 group-hover:text-orange-700">{{ label }}</span>
        </router-link>
    </li>
</template>

<script>
    export default {
        props: {
            to: {
                type: String,
                default: '#',
                required: true
            },
            label: {
                type: String,
                default: 'Name',
                required: true
            },
            icon: {
                type: String,
                default: 'fa-solid fa-bars',
                required: true
            }
        }
    }
</script>

<style scoped>
    .router-link-exact-active {
        --tw-bg-opacity: 1;
        background-color: rgb(243 244 246 / var(--tw-bg-opacity));
    }
</style>